import { ReactElement } from 'react';
import { DashboardContainer } from '../../../../modules/common/dashboard/DashboardContainer';
import { AdminHeader } from '../../../modules/admin/components/AdminHeader';
import { AdminRoute } from '../../../routes/admin/admin.route';

export const AdminView = (): ReactElement => {
  return (
    <DashboardContainer>
      <AdminHeader />
      <AdminRoute />
    </DashboardContainer>
  );
};
